/**
 * withDataBins
 * HOC for wrapping the provided component with DataBinsProvider
 */

import React from 'react'

import DataBinsProvider from './data-bins-provider'

export default function withDataBins (WrappedComponent) {
  return function DataBinsProviderHOC(props) {
    return (
      <DataBinsProvider>
        <WrappedComponent {...props} />
      </DataBinsProvider>
    )
  }
}
